import axios from "axios";
import config from "../config";

const logService = axios.create({
  baseURL: config("service").log
});

export default logService;
